import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isStaleBuild, useStaleBuild } from '../lib/app-build';
import { STALE_BUILD_LABEL, STALE_BUILD_LINE, STALE_BUILD_RELOAD } from '../lib/copy';
import { Button } from './ui/button';
import './stale-build.css';

/**
 * **The tab is running old code** (2026-10-14, `lib/app-build.ts`): it reloads
 * itself at the next navigation, and says so until then.
 *
 * At a move to another page and not the moment it learns, because a reload in place would
 * take a half-typed note or an open dialog with it; leaving a page has already
 * let go of those. The reload lands on the page being navigated to, which the
 * router has already put in the address bar.
 */
export function StaleBuild() {
  const stale = useStaleBuild();
  const { pathname } = useLocation();
  const shown = useRef(pathname);

  /* The path, not the location: a page that keeps its state in the address (the
     Knowledge base search box writes its query there as you type, a list's
     filter chips, a `?create=1` dialog) changes the location without leaving the
     page, and reloading there would take the typing with it. */
  useEffect(() => {
    if (pathname === shown.current) return;
    shown.current = pathname;
    if (isStaleBuild()) window.location.reload();
  }, [pathname]);

  return stale ? <StaleBuildView onReload={() => window.location.reload()} /> : null;
}

export function StaleBuildView({ onReload }: { onReload: () => void }) {
  return (
    <aside className="demo-notice stale-build">
      <strong>{STALE_BUILD_LABEL}</strong>
      <span>{STALE_BUILD_LINE}</span>
      <Button variant="act" tiny onClick={onReload}>
        {STALE_BUILD_RELOAD}
      </Button>
    </aside>
  );
}
